/**
 * A helper that handles the common behavior for handling a
 * dropdown value change in the order list component.
 * 
 * When an "all" option is selected, it returns only that
 * option and removes all other options, else it appends
 * the newly selected item to the dataset.
 */
export const OrderDropdownFilterSelectedHelper = (data, selectedItem, allItemConstant) => {
      // If they've selected "all", set that as the only selected option
      if (selectedItem.id === allItemConstant.id) {
        return [allItemConstant];
      }

      // If they've selected a specific item while "all" is selected, remove "all"
      return [...data, selectedItem].filter(item => item.id !== allItemConstant.id);
}